module.exports = __webpack_public_path__ + "static/media/createAreaTam.a0873845.jpg";